import gql from "graphql-tag"

const topicFragment = gql`
  fragment topicFragment on Topic {
    id
    slug
    name
    type
    description
    previewDescription
    logo
    topicMetadata {
      sectorsTracked {
        name
        slug
      }
      tsisStartDate
      etsStartDate
    }
    active
    acquiredBy {
      name
      slug
    }
    dataId
  }
`

const vendorFragment = gql`
  fragment vendorFragment on Topic {
    ratings {
      timeframe
      value
    }
    outlook {
      title
      text
    }
    takeaways {
      value
    }
    surveyRespondents {
      count
    }
    fortune500
    sp500
    global2000
    tsisSurveyAnswerDistribution {
      adoption
      increase
      flat
      decrease
      replacing
    }
    tsisReportURL
    rampImages
    components {
      ... on Image {
        title
        subtitle
        imageURL
        slug
        hasLegend
      }
      ... on Quotes {
        quotes {
          text
          speaker
          eventIdentifier
          date
        }
      }
    }
  }
`

const getVendorPage = gql`
  query GetVendorPage($slug: String!, $type: String!) {
    page(slug: $slug, type: $type) {
      ... on Topic {
        ...topicFragment
        ...vendorFragment
      }
    }
    siteSettings {
      id
      vendorPageBannerMessage
      showVendorPageBanner
    }
  }
  ${topicFragment}
  ${vendorFragment}
`

const getSectorPage = gql`
  query GetSectorPage($slug: String!, $type: String!) {
    page(slug: $slug, type: $type) {
      ... on Topic {
        ...topicFragment
      }
    }
  }
  ${topicFragment}
`
const getProduct = gql`
  query GetSectorPage($slug: String) {
    product(slug: $slug) {
      id
      isPurchased
      isSpecialAccess
      free
    }
  }
`

export { getSectorPage, getVendorPage, getProduct }
